

<!-- page content start -->
<ion-header class="header -primary" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar color="primary" mode="md">
      <ion-title slot="start" style="padding-left:0px"><img src="../../assets/logo_table42.svg"></ion-title>
      <!--app-top-right slot="end"></app-top-right-->
      <ion-buttons slot="end">
  
      <!--<ion-button>
        <ion-icon class="profile"></ion-icon>
      </ion-button>-->

        <ion-select interface="action-sheet" [selectedText]="translateService.currentLang.toUpperCase()" style="padding-left:5px; max-width:100%; color: white; font-size: small;" [ngModel]="translateService.currentLang" (ionChange)="onChange($event)">
        <ion-select-option value="sl">SL - Slovenščina</ion-select-option>
        <ion-select-option value="en">EN - English</ion-select-option>
        <ion-select-option value="de">DE - Deutsch</ion-select-option>
        <ion-select-option value="it">IT - Italiano</ion-select-option>
        <!--ion-select-option value="hr">HR - Hrvatski</ion-select-option-->
        </ion-select>

        <ion-menu-button slot="end" autoHide="false" color="light"></ion-menu-button>

      <!--<ion-button (click)="logout($event)">Odjava</ion-button>-->

      

      </ion-buttons>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<!--ion-content color="primary">

<h3 class="ion-text-center" style="margin-top:250px; padding:20px;">Sprejemanje rezervacij se začne v ponedeljek, 3. oktobra!</h3>

</ion-content-->

<ion-content>
  <ion-grid fixed class="ion-no-padding">
  
    <!--<div  class="ion-padding">

      <ion-label>
        <h1>Vsi restavracijai na enem mestu</h1>
        <p>Poišči prost termin in se naroči prek spleta!</p>
      </ion-label>

      <ion-segment padding-vertical (ionChange)="onSearchModeChanged($event)">
        <ion-segment-button value="service" checked>
          <ion-label>Išči po storitvi</ion-label>
        </ion-segment-button>
        <ion-segment-button value="keyword">
          <ion-label>Išči po imenu</ion-label>
        </ion-segment-button>
      </ion-segment>

      <app-search-by-service *ngIf="'service' === searchMode"></app-search-by-service>
      <app-search-by-keyword *ngIf="'keyword' === searchMode"></app-search-by-keyword>

    </div>-->


    <!--div  class="ion-padding searchbox">

      <ion-label class="searchbox__label">
        <h1>Vsi najboljše restavracije na enem mestu!</h1>
      </ion-label>

      <ion-row>
        <ion-col size-xl="5" size-xs="12" class="searchbox__col">

      <ion-segment [(ngModel)]="searchMode" mode="md" class="search-segment">
        <ion-segment-button value="service" class="search-category btn--small" mode="md">
          <ion-label>Išči po storitvah</ion-label>
        </ion-segment-button>
        <ion-segment-button (click)="openSearchByNameModal()" value="keyword" class="search-category btn--small" mode="md">
          <ion-label>Išči po imenu</ion-label>
        </ion-segment-button>
      </ion-segment>

      <app-search-by-service></app-search-by-service> 

        </ion-col>


      </ion-row>

    </div-->

    <!--ion-grid class="hidden-sm-down why-booking ion-padding">
      <ion-row>
        <ion-col size="12">
          <h2>Zakaj Book123.com?</h2>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2">
          <ion-icon class="saloon"></ion-icon>
        </ion-col>
        <ion-col size="6">
          <p>Vse restavracije na enem mestu.</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2">
          <ion-icon class="calendar"></ion-icon>
        </ion-col>
        <ion-col size="6">
          <p>Hitro in enostavno naročanje</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2">
          <ion-icon class="sms"></ion-icon>
        </ion-col>
        <ion-col size="7">
          <p>SMS obveščanje in ocenjevanje</p>
        </ion-col>
      </ion-row>
    </ion-grid-->


    <!--ion-grid class="ion-no-padding">
      <ion-row>
        
        <ion-col [ngClass]="{'hidden-sm-down': i===1, 'hidden-lg-down': i>1}"  *ngFor="let real of (new$ | async | randomOrder); let i = index;" size-xs="12" size-md="6" size-xl="4">

          <ion-card [routerLink]="real?.getUrlArr()" class="advertisment--saloon clickable" button="false" mode="ios">
            <div class="sticky-discount sticky-discount">Novo</div>
            <ion-img class="advertisment--saloon__img" [src]="getAvatarUrl( real?.galleryFirst?.fileName )"></ion-img>

            <ion-card-header   class="ion-no-padding">
              <ion-card-title class="advertisment--saloon__title">{{ real?.getComposedName() }}</ion-card-title>
              <ion-card-subtitle class="advertisment--saloon__subtitle">{{ real?.newOnMarketplaceDescription }}</ion-card-subtitle>
              <p>
                <a class="pp-link">VEČ O SALONU</a>
              </p>
            </ion-card-header>
          </ion-card>
        </ion-col>
        
      </ion-row>
    </ion-grid-->



  </ion-grid>
  

  <!-- div style="background-color: black;" class="ion-no-padding">

    <ion-grid fixed class="ion-no-padding">
      <ion-row>
  
        <ng-container *ngFor="let real of (exposed$ | async | randomOrder:3:6 ); let i = index;">
          <ion-col [ngClass]="{'hidden-sm-down': i===1, 'hidden-lg-down': i>1}" size-xs="12" size-md="6" size-xl="4">
            <div class="advertisment--black clickable" [routerLink]="real?.getUrlArr()">
              <img [src]="getAvatarUrl( real?.avatar?.fileName )" class="advertisment--black__logo">
              <h3 class="advertisment--black__title">{{ real?.getComposedName() }}</h3>
              <p class="advertisment--black__desc">{{ real?.exposedOnMarketplaceDescription }}</p>
              <a class="pp-link">VEČ O SALONU</a>
            </div>
          </ion-col>
        </ng-container>
      </ion-row>
    </ion-grid>

  </div-->

  <div style="background-color: white; padding-top:0px">

  <ion-grid fixed class="ion-no-padding">

    <!--<ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size-xs="12" size-md="6" size-xl="4">
          <ion-card [routerLink]="['/restavracija', 32, 'viki-s-place-vosnjakova']" class="advertisment--saloon" button="false" mode="ios">
            <div class="sticky-discount sticky-discount">Novo</div>
            <ion-img class="advertisment--saloon__img" src="https://docs.api.pricepilot.io/58ee186b65629.jpeg"></ion-img>

            <ion-card-header   class="ion-no-padding">
              <ion-card-title class="advertisment--saloon__title">Viki’s Place</ion-card-title>
              <ion-card-subtitle class="advertisment--saloon__subtitle">Nov restavracija Viki's Place na Vošnjakovi - Dvořakova!</ion-card-subtitle>
              <p>
                <a class="pp-link">VEČ O SALONU</a>
              </p>
            </ion-card-header>
          </ion-card>
        </ion-col>
        <ion-col class="hidden-sm-down" size-xs="12" size-md="6" size-xl="4">
          <ion-card [routerLink]="['/restavracija', 32, 'viki-s-place-vosnjakova']" class="advertisment--saloon" button="false" mode="ios">
            <div class="sticky-discount sticky-discount">Novo</div>
            <ion-img class="advertisment--saloon__img" src="https://docs.api.pricepilot.io/5ebe6ed80e32b.jpeg"></ion-img>

            <ion-card-header   class="ion-no-padding">
              <ion-card-title class="advertisment--saloon__title">YMS Aleja</ion-card-title>
              <ion-card-subtitle class="advertisment--saloon__subtitle">Najbolj odštekano striženje po novem tudi v nakupovalnem centru Aleja v Šiški</ion-card-subtitle>
              <p>
                <a class="pp-link">VEČ O SALONU</a>
              </p>
            </ion-card-header>
          </ion-card>
        </ion-col>
        <ion-col class="hidden-lg-down" size-xs="12" size-lg="6" size-xl="4">
          <ion-card [routerLink]="['/restavracija', 32, 'viki-s-place-vosnjakova']" class="advertisment--saloon" button="false" mode="ios">
            <div class="sticky-discount sticky-discount">Novo</div>
            <ion-img class="advertisment--saloon__img" src="https://dmstudio.si/wp-content/uploads/2020/11/dm-Studio-Kranj-2020-Photo-Foto-DD-119-e1605190158732.jpg"></ion-img>

            <ion-card-header   class="ion-no-padding">
              <ion-card-title class="advertisment--saloon__title">dm Studio Kranj</ion-card-title>
              <ion-card-subtitle class="advertisment--saloon__subtitle">DM od sedaj tudi s svojim restavracijaom v Kranju</ion-card-subtitle>
              <p>
                <a class="pp-link">VEČ O SALONU</a>
              </p>
            </ion-card-header>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>-->

    <div class="ion-padding">
     <h4 class="popular-saloons-title">{{ 'LANDING.FIND_A_RESTAURANT' | translate }}</h4>
     <h6 style="margin-bottom:20px;">{{ 'LANDING.TABLE_BOOKING' | translate }}</h6>
      
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ng-container *ngFor="let real of (exposed$ | async | randomOrder  ); let i = index;">
          <ion-col  size-xs="12" size-md="6" size-xl="4">
            <div class="popular-saloons fake-card__first clickable" [routerLink]="real?.getUrlArr()" >
              <ion-img class="popular-saloons__img" [src]="getAvatarUrl( real?.galleryFirst?.fileName )"></ion-img>
              <h4 class="popular-saloons__name">{{ real?.getComposedName() }}</h4>
              <p class="popular-saloons__address">{{ real?.address }}</p>
              <p class="popular-saloons__desc">{{ real?.exposedOnMarketplaceDescription }}</p>
              <!--<p class="popular-saloons__rating">8.1 <span>(144 ocen)</span></p>-->
              <!--span class="popular-saloons__advert ion-float-right">Teden restavracij</span-->
            </div>
          </ion-col>
          </ng-container>
        </ion-row>
      </ion-grid>
    </div>

    <!--<div class="ion-padding">
      <h4 class="ongoing-sales-title">Akcije in popusti</h4>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col [ngClass]="{'hidden-sm-down': i===1, 'hidden-lg-down': i>1}"  *ngFor="let real of (specialOffer$ | async | randomOrder); let i = index;" size-xs="12" size-md="6" size-xl="4" class="fake-card__first">
            <div class="ongoing-sales clickable" [routerLink]="real?.getUrlArr()">
              <div *ngIf="real?.specialOfferOnMarketplaceGift" class="sticky-discount sticky-discount--hot">Darilo</div>
              <ion-img class="ongoing-sales__img" [src]="getAvatarUrl( real.galleryFirst.fileName )"></ion-img>
              <p class="ongoing-sales__shop-name">{{ real?.getComposedName() }}</p>
              <h3 class="ongoing-sales__service-title">{{ real?.specialOfferOnMarketplaceDescription }}</h3>
              <p class="ongoing-sales__discount" *ngIf="real?.specialOfferOnMarketplacePrice">{{ real?.specialOfferOnMarketplacePrice | number:'1.0-2' }} € <span class="prev-price">55€</p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-button class="btn--default ongoing-sales-btn" expand="full">VSE AKCIJE IN POPUSTI</ion-button>
    </div>-->

    
    <!--ion-grid class="ion-padding">

      <ion-row>
        <ion-col size="12">
          <h4 class="discover-saloons-title">Odkrijte restavracije v…</h4>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="4" >
          <div class="discover-saloons clickable" [routerLink]="['/ljubljana']">
            <ion-img class="discover-saloons__img" src="/assets/images/ljubljana.jpg"></ion-img>
            <h3 class="discover-saloons__city">Ljubljana</h3>
          </div>
        </ion-col>
        <ion-col size="4">
          <div class="discover-saloons clickable" [routerLink]="['/maribor']">
            <ion-img class="discover-saloons__img" src="/assets/images/maribor.jpg"></ion-img>
            <h3 class="discover-saloons__city">Maribor</h3>
          </div>
        </ion-col>
        <ion-col size="4">
          <div class="discover-saloons clickable" [routerLink]="['/novo-mesto']">
            <ion-img class="discover-saloons__img" src="/assets/images/novo-mesto.jpg"></ion-img>
            <h3 class="discover-saloons__city">Novo mesto</h3>
          </div>
        </ion-col>
      </ion-row>
      <ion-row style="margin-top:20px">
        <ion-col size="4">
          <div class="discover-saloons clickable" [routerLink]="['/kranj']">
            <ion-img class="discover-saloons__img" src="/assets/images/kranj.jpg"></ion-img>
            <h3 class="discover-saloons__city">Kranj</h3>
          </div>
        </ion-col>
        <ion-col size="4">
          <div class="discover-saloons clickable" [routerLink]="['/koper']">
            <ion-img class="discover-saloons__img" src="/assets/images/koper.jpg"></ion-img>
            <h3 class="discover-saloons__city">Koper</h3>
          </div>
        </ion-col>
        <ion-col size="4">
          <div class="discover-saloons clickable" [routerLink]="['/nova-gorica']">
            <ion-img class="discover-saloons__img" src="/assets/images/nova-gorica.jpg"></ion-img>
            <h3 class="discover-saloons__city">Nova Gorica</h3>
          </div>
        </ion-col>
      </ion-row>

    </ion-grid-->




  </ion-grid>

  </div>

  <app-footer>

  </app-footer>
</ion-content>

